(function () {
  'use strict';

  var ELEMENTAL_VENDOR = 'Elemental / by WEATHERCRAFT';
  var ELEMENTAL_CART_URL = '/cart?view=elemental';

  function normalise(value) {
    return String(value || '').trim().toLowerCase();
  }

  function itemBrand(item) {
    var vendor = normalise(item.vendor);
    var title = normalise(item.product_title || item.title);
    if (vendor === normalise(ELEMENTAL_VENDOR) || title.indexOf('elemental') !== -1) return 'elemental';
    return 'weathercraft';
  }

  function cartBrands(cart) {
    var brands = new Set();
    (cart.items || []).forEach(function (item) { brands.add(itemBrand(item)); });
    return brands;
  }

  function buttonBrand(button) {
    if (button && button.dataset.storefrontBrand) return button.dataset.storefrontBrand;
    return document.body.classList.contains('template-elemental') ? 'elemental' : 'weathercraft';
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function clearCart() {
    return fetch(cartRoot() + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({})
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to clear cart');
      return response.json();
    });
  }

  function addElemental(form) {
    var formData = new FormData(form);
    return fetch(form.action, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Unable to add this wine');
        });
      }
      return response.json();
    });
  }

  function rememberNotice(message) {
    try { window.sessionStorage.setItem('storefront_brand_notice', message); } catch (error) {}
  }

  function showRememberedNotice() {
    var message = '';
    try {
      message = window.sessionStorage.getItem('storefront_brand_notice') || '';
      window.sessionStorage.removeItem('storefront_brand_notice');
    } catch (error) {}
    if (!message) return;

    var notice = document.createElement('div');
    notice.className = 'elemental-brand-notice';
    notice.setAttribute('role', 'status');
    notice.textContent = message;
    document.body.appendChild(notice);
    window.setTimeout(function () { notice.remove(); }, 6500);
  }

  function releaseWeathercraftButton(button) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    delete button.dataset.brandGuardPending;
  }

  function submitWeathercraftForm(form, button) {
    var released = false;
    var timeout;

    function release() {
      if (released) return;
      released = true;
      window.clearTimeout(timeout);
      releaseWeathercraftButton(button);
      document.removeEventListener('cart:update', release);
      document.removeEventListener('cart:error', release);
    }

    button.disabled = false;

    try {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(button);
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } catch (error) {
      release();
      throw error;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    document.addEventListener('cart:update', release, { once: true });
    document.addEventListener('cart:error', release, { once: true });
    timeout = window.setTimeout(release, 5000);
  }

  function chooseProductHandle(button) {
    var action = button.getAttribute('on:click') || '';
    var actionMatch = action.match(/\/showDialog\/([^\s/?#]+)/);
    if (actionMatch) return decodeURIComponent(actionMatch[1]);

    var card = button.closest('product-card, .product-card');
    var link = card ? card.querySelector('.product-card__link[href*="/products/"]') : null;
    if (!link) return '';
    var pathMatch = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return pathMatch ? decodeURIComponent(pathMatch[1]) : '';
  }

  function ensureChooseDialog(button) {
    var handle = chooseProductHandle(button);
    if (!handle) return;

    window.setTimeout(function () {
      var host = document.getElementById('quick-add-dialog');
      var dialog = host ? host.querySelector('dialog') : null;
      if (dialog && dialog.open) return;

      if (host && typeof host.showDialog === 'function') {
        host.showDialog(handle);
        return;
      }

      var card = button.closest('product-card, .product-card');
      var link = card ? card.querySelector('.product-card__link[href*="/products/"]') : null;
      if (link && link.href) window.location.assign(link.href);
    }, 80);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[name="add"], [data-add-to-cart]');
    if (!button) return;
    var form = button.form || button.closest('form[action*="/cart/add"]');
    if (!form) return;

    var targetBrand = buttonBrand(button);
    if (targetBrand !== 'elemental') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    button.disabled = true;

    fetchCart()
      .then(function (cart) {
        var brands = cartBrands(cart);
        if (brands.size && !brands.has('elemental')) {
          rememberNotice('Your Weathercraft cart was cleared because Elemental and Weathercraft are kept as separate stores.');
          return clearCart();
        }
        return cart;
      })
      .then(function () { return addElemental(form); })
      .then(function () { window.location.assign(ELEMENTAL_CART_URL); })
      .catch(function (error) {
        button.disabled = false;
        window.alert(error.message || 'Something went wrong. Please try again.');
      });
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[name="add"], [data-add-to-cart]');
    if (!button || buttonBrand(button) !== 'weathercraft') return;

    if (button.matches('.quick-add__button--choose') || button.type === 'button') {
      if (button.matches('.quick-add__button--choose')) ensureChooseDialog(button);
      return;
    }

    var form = button.form || button.closest('form[action*="/cart/add"]');
    if (!form || button.dataset.brandGuardPending === 'true') return;

    event.preventDefault();
    button.dataset.brandGuardPending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetchCart()
      .then(function (cart) {
        var brands = cartBrands(cart);
        if (!brands.has('elemental')) return cart;

        rememberNotice('Your Elemental cart was cleared because Elemental and Weathercraft are kept as separate stores.');
        return clearCart();
      })
      .then(function () {
        submitWeathercraftForm(form, button);
      })
      .catch(function (error) {
        releaseWeathercraftButton(button);
        window.alert(error.message || 'Something went wrong. Please try again.');
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showRememberedNotice);
  } else {
    showRememberedNotice();
  }
})();
